var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.168 4.032l-2.536-.37-1.134-2.298a.556.556 0 00-.996 0L3.368 3.663l-2.536.37a.556.556 0 00-.308.947L2.36 6.768l-.434 2.526a.555.555 0 00.806.586L5 8.687 7.269 9.88a.556.556 0 00.806-.586L7.64 6.768 9.476 4.98a.556.556 0 00-.308-.948zM6.746 6.477l.412 2.403L5 7.746 2.842 8.88l.411-2.403-1.746-1.702 2.413-.35L5 2.237l1.08 2.188 2.413.35-1.747 1.702z",
    fill: "#F59E0B"
  })));
}
export default SvgStarOutline;